// extracted by mini-css-extract-plugin
export default {"container":"whatsAppInstances_container__RNnK7","actions":"whatsAppInstances_actions__Dtt45"};